import { useSearchParams } from "react-router-dom";
import TeacherLive from "../../components/ai-tutor/TeacherLive";

export default function AiTutorLivePage() {
  const [searchParams] = useSearchParams();
  const lessonParam = searchParams.get("lesson");
  const initialLessonNo =
    lessonParam != null
      ? (() => {
          const n = parseInt(lessonParam, 10);
          return Number.isNaN(n) || n < 1 ? undefined : n;
        })()
      : undefined;
  const sublessonParam = searchParams.get("sublesson");
  const initialSublessonNo =
    sublessonParam != null && sublessonParam.trim() !== "" ? sublessonParam.trim() : undefined;
  const chunkParam = searchParams.get("chunk");
  const initialChunkOrderIndex =
    chunkParam != null && chunkParam.trim() !== ""
      ? (() => {
          const n = parseInt(chunkParam, 10);
          return Number.isNaN(n) || n < 0 ? undefined : n;
        })()
      : undefined;

  return (
    <div className="h-dvh min-h-0 max-h-dvh flex flex-col overflow-hidden">
      <TeacherLive
        onEnd={() => window.history.back()}
        tutorType="ai_tutor"
        showLessonsPanel={true}
        initialLessonNo={initialLessonNo}
        initialSublessonNo={initialSublessonNo}
        initialChunkOrderIndex={initialChunkOrderIndex}
      />
    </div>
  );
}